/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getFeV1RecoveryCashOnDeliveriesId$Json } from '../fn/recovery-cash-on-delivery/get-fe-v-1-recovery-cash-on-deliveries-id-json';
import { GetFeV1RecoveryCashOnDeliveriesId$Json$Params } from '../fn/recovery-cash-on-delivery/get-fe-v-1-recovery-cash-on-deliveries-id-json';
import { getFeV1RecoveryCashOnDeliveriesId$Plain } from '../fn/recovery-cash-on-delivery/get-fe-v-1-recovery-cash-on-deliveries-id-plain';
import { GetFeV1RecoveryCashOnDeliveriesId$Plain$Params } from '../fn/recovery-cash-on-delivery/get-fe-v-1-recovery-cash-on-deliveries-id-plain';
import { postFeV1RecoveryCashOnDeliveries$Json } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cash-on-deliveries-json';
import { PostFeV1RecoveryCashOnDeliveries$Json$Params } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cash-on-deliveries-json';
import { postFeV1RecoveryCashOnDeliveries$Plain } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cash-on-deliveries-plain';
import { PostFeV1RecoveryCashOnDeliveries$Plain$Params } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cash-on-deliveries-plain';
import { postFeV1RecoveryCashOnDeliveriesExport$Json } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cash-on-deliveries-export-json';
import { PostFeV1RecoveryCashOnDeliveriesExport$Json$Params } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cash-on-deliveries-export-json';
import { postFeV1RecoveryCashOnDeliveriesExport$Plain } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cash-on-deliveries-export-plain';
import { PostFeV1RecoveryCashOnDeliveriesExport$Plain$Params } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cash-on-deliveries-export-plain';
import { postFeV1RecoveryCodsDataForCreation$Json } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cods-data-for-creation-json';
import { PostFeV1RecoveryCodsDataForCreation$Json$Params } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cods-data-for-creation-json';
import { postFeV1RecoveryCodsDataForCreation$Plain } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cods-data-for-creation-plain';
import { PostFeV1RecoveryCodsDataForCreation$Plain$Params } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cods-data-for-creation-plain';
import { RecoveryCashOnDeliveryDataForCreationResponse } from '../models/recovery-cash-on-delivery-data-for-creation-response';
import { RecoveryCashOnDeliveryPaginatedResponse } from '../models/recovery-cash-on-delivery-paginated-response';
import { RecoveryCashOnDeliveryResponse } from '../models/recovery-cash-on-delivery-response';

@Injectable({ providedIn: 'root' })
export class RecoveryCashOnDeliveryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postFeV1RecoveryCashOnDeliveries()` */
  static readonly PostFeV1RecoveryCashOnDeliveriesPath = '/v1/recovery-cash-on-deliveries';

  /**
   * Gets all recovery cash-on-delivery records based on the provided request parameters.
   *
   * Gets all recovery cash-on-delivery records based on the provided request parameters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1RecoveryCashOnDeliveries$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCashOnDeliveries$Plain$Response(params?: PostFeV1RecoveryCashOnDeliveries$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveryCashOnDeliveryPaginatedResponse>> {
    return postFeV1RecoveryCashOnDeliveries$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all recovery cash-on-delivery records based on the provided request parameters.
   *
   * Gets all recovery cash-on-delivery records based on the provided request parameters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1RecoveryCashOnDeliveries$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCashOnDeliveries$Plain(params?: PostFeV1RecoveryCashOnDeliveries$Plain$Params, context?: HttpContext): Observable<RecoveryCashOnDeliveryPaginatedResponse> {
    return this.postFeV1RecoveryCashOnDeliveries$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<RecoveryCashOnDeliveryPaginatedResponse>): RecoveryCashOnDeliveryPaginatedResponse => r.body)
    );
  }

  /**
   * Gets all recovery cash-on-delivery records based on the provided request parameters.
   *
   * Gets all recovery cash-on-delivery records based on the provided request parameters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1RecoveryCashOnDeliveries$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCashOnDeliveries$Json$Response(params?: PostFeV1RecoveryCashOnDeliveries$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveryCashOnDeliveryPaginatedResponse>> {
    return postFeV1RecoveryCashOnDeliveries$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all recovery cash-on-delivery records based on the provided request parameters.
   *
   * Gets all recovery cash-on-delivery records based on the provided request parameters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1RecoveryCashOnDeliveries$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCashOnDeliveries$Json(params?: PostFeV1RecoveryCashOnDeliveries$Json$Params, context?: HttpContext): Observable<RecoveryCashOnDeliveryPaginatedResponse> {
    return this.postFeV1RecoveryCashOnDeliveries$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<RecoveryCashOnDeliveryPaginatedResponse>): RecoveryCashOnDeliveryPaginatedResponse => r.body)
    );
  }

  /** Path part for operation `getFeV1RecoveryCashOnDeliveriesId()` */
  static readonly GetFeV1RecoveryCashOnDeliveriesIdPath = '/v1/recovery-cash-on-deliveries/{id}';

  /**
   * Gets a specific recovery cash-on-delivery record by its unique identifier.
   *
   * Gets a specific recovery cash-on-delivery record by its unique identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1RecoveryCashOnDeliveriesId$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1RecoveryCashOnDeliveriesId$Plain$Response(params: GetFeV1RecoveryCashOnDeliveriesId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveryCashOnDeliveryResponse>> {
    return getFeV1RecoveryCashOnDeliveriesId$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a specific recovery cash-on-delivery record by its unique identifier.
   *
   * Gets a specific recovery cash-on-delivery record by its unique identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1RecoveryCashOnDeliveriesId$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1RecoveryCashOnDeliveriesId$Plain(params: GetFeV1RecoveryCashOnDeliveriesId$Plain$Params, context?: HttpContext): Observable<RecoveryCashOnDeliveryResponse> {
    return this.getFeV1RecoveryCashOnDeliveriesId$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<RecoveryCashOnDeliveryResponse>): RecoveryCashOnDeliveryResponse => r.body)
    );
  }

  /**
   * Gets a specific recovery cash-on-delivery record by its unique identifier.
   *
   * Gets a specific recovery cash-on-delivery record by its unique identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1RecoveryCashOnDeliveriesId$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1RecoveryCashOnDeliveriesId$Json$Response(params: GetFeV1RecoveryCashOnDeliveriesId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveryCashOnDeliveryResponse>> {
    return getFeV1RecoveryCashOnDeliveriesId$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a specific recovery cash-on-delivery record by its unique identifier.
   *
   * Gets a specific recovery cash-on-delivery record by its unique identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1RecoveryCashOnDeliveriesId$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1RecoveryCashOnDeliveriesId$Json(params: GetFeV1RecoveryCashOnDeliveriesId$Json$Params, context?: HttpContext): Observable<RecoveryCashOnDeliveryResponse> {
    return this.getFeV1RecoveryCashOnDeliveriesId$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<RecoveryCashOnDeliveryResponse>): RecoveryCashOnDeliveryResponse => r.body)
    );
  }

  /** Path part for operation `postFeV1RecoveryCashOnDeliveriesExport()` */
  static readonly PostFeV1RecoveryCashOnDeliveriesExportPath = '/v1/recovery-cash-on-deliveries/export';

  /**
   * Exports all recovery cash-on-delivery records based on the provided request parameters. This endpoint is intended for administrative users and will return a file containing the exported data.
   *
   * Exports all recovery cash-on-delivery records based on the provided request parameters. This endpoint is intended for administrative users and will return a file containing the exported data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1RecoveryCashOnDeliveriesExport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCashOnDeliveriesExport$Plain$Response(params?: PostFeV1RecoveryCashOnDeliveriesExport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postFeV1RecoveryCashOnDeliveriesExport$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Exports all recovery cash-on-delivery records based on the provided request parameters. This endpoint is intended for administrative users and will return a file containing the exported data.
   *
   * Exports all recovery cash-on-delivery records based on the provided request parameters. This endpoint is intended for administrative users and will return a file containing the exported data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1RecoveryCashOnDeliveriesExport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCashOnDeliveriesExport$Plain(params?: PostFeV1RecoveryCashOnDeliveriesExport$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postFeV1RecoveryCashOnDeliveriesExport$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Exports all recovery cash-on-delivery records based on the provided request parameters. This endpoint is intended for administrative users and will return a file containing the exported data.
   *
   * Exports all recovery cash-on-delivery records based on the provided request parameters. This endpoint is intended for administrative users and will return a file containing the exported data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1RecoveryCashOnDeliveriesExport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCashOnDeliveriesExport$Json$Response(params?: PostFeV1RecoveryCashOnDeliveriesExport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postFeV1RecoveryCashOnDeliveriesExport$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Exports all recovery cash-on-delivery records based on the provided request parameters. This endpoint is intended for administrative users and will return a file containing the exported data.
   *
   * Exports all recovery cash-on-delivery records based on the provided request parameters. This endpoint is intended for administrative users and will return a file containing the exported data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1RecoveryCashOnDeliveriesExport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCashOnDeliveriesExport$Json(params?: PostFeV1RecoveryCashOnDeliveriesExport$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postFeV1RecoveryCashOnDeliveriesExport$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `postFeV1RecoveryCodsDataForCreation()` */
  static readonly PostFeV1RecoveryCodsDataForCreationPath = '/v1/recovery-cash-on-deliveries/data-for-creation';

  /**
   * Retrieves necessary data for creating a recovery COD and checks if it already exists.
   *
   * Retrieves necessary data for creating a recovery COD and checks if it already exists.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1RecoveryCodsDataForCreation$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCodsDataForCreation$Plain$Response(params?: PostFeV1RecoveryCodsDataForCreation$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveryCashOnDeliveryDataForCreationResponse>> {
    return postFeV1RecoveryCodsDataForCreation$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves necessary data for creating a recovery COD and checks if it already exists.
   *
   * Retrieves necessary data for creating a recovery COD and checks if it already exists.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1RecoveryCodsDataForCreation$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCodsDataForCreation$Plain(params?: PostFeV1RecoveryCodsDataForCreation$Plain$Params, context?: HttpContext): Observable<RecoveryCashOnDeliveryDataForCreationResponse> {
    return this.postFeV1RecoveryCodsDataForCreation$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<RecoveryCashOnDeliveryDataForCreationResponse>): RecoveryCashOnDeliveryDataForCreationResponse => r.body)
    );
  }

  /**
   * Retrieves necessary data for creating a recovery COD and checks if it already exists.
   *
   * Retrieves necessary data for creating a recovery COD and checks if it already exists.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1RecoveryCodsDataForCreation$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCodsDataForCreation$Json$Response(params?: PostFeV1RecoveryCodsDataForCreation$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveryCashOnDeliveryDataForCreationResponse>> {
    return postFeV1RecoveryCodsDataForCreation$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves necessary data for creating a recovery COD and checks if it already exists.
   *
   * Retrieves necessary data for creating a recovery COD and checks if it already exists.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1RecoveryCodsDataForCreation$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCodsDataForCreation$Json(params?: PostFeV1RecoveryCodsDataForCreation$Json$Params, context?: HttpContext): Observable<RecoveryCashOnDeliveryDataForCreationResponse> {
    return this.postFeV1RecoveryCodsDataForCreation$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<RecoveryCashOnDeliveryDataForCreationResponse>): RecoveryCashOnDeliveryDataForCreationResponse => r.body)
    );
  }

}
